import { createRouter, createWebHistory } from 'vue-router';
import SteamPlaytimeTracker from '../views/SteamPlaytimeTracker.vue';
import SteamReplay from '../views/SteamReplay.vue';
import SteamRetrospective from '../views/SteamRetrospective.vue';
import SteamCharts from '../views/SteamCharts.vue';
import SteamGameKeywords from '../views/SteamGameKeywords.vue';
import SteamPlayHistory from '../views/SteamPlayHistory.vue';
import SteamWastedHours from '../views/SteamWastedHours.vue';
import HowToCheckSteamHours from '../views/HowToCheckSteamHours.vue';
import SteamTotalHours from '../views/SteamTotalHours.vue';
import SteamHoursPerDay from '../views/SteamHoursPerDay.vue';
import Blog from '../views/Blog.vue';
import SteamDeckSale from '../views/SteamDeckSale.vue';
import XboxGamePassPriceUpdate from '../views/XboxGamePassPriceUpdate.vue';
import SteamMachinePrice from '../views/SteamMachinePrice.vue';
import GamePassSteamDeck from '../views/GamePassSteamDeck.vue';
import MostPlayedSeptember2026 from '../views/MostPlayedSeptember2026.vue';
import NewsPost from '../views/NewsPost.vue';
import Privacy from '../views/Privacy.vue';
import About from '../views/About.vue';
import Dashboard from '../views/Dashboard.vue';
import NotFound from '../views/NotFound.vue';
import Settings from '../views/Settings.vue';
import { newsPosts } from '../utils/newsPosts';

const routes = [
    {
        path: '/page/steam-playtime-tracker',
        name: 'SteamPlaytimeTracker',
        component: SteamPlaytimeTracker,
    },
    {
        path: '/page/steam-replay',
        name: 'SteamReplay',
        component: SteamReplay,
    },
    {
        path: '/page/steam-retrospective',
        name: 'SteamRetrospective',
        component: SteamRetrospective,
    },
    {
        path: '/page/steam-charts',
        name: 'SteamCharts',
        component: SteamCharts,
    },
    {
        path: '/page/steam-game-keywords',
        name: 'SteamGameKeywords',
        component: SteamGameKeywords,
    },
    {
        path: '/page/steam-play-history',
        name: 'SteamPlayHistory',
        component: SteamPlayHistory,
    },
    {
        path: '/page/steam-wasted-hours',
        name: 'SteamWastedHours',
        component: SteamWastedHours,
    },
    {
        path: '/page/how-to-check-steam-hours',
        name: 'HowToCheckSteamHours',
        component: HowToCheckSteamHours,
    },
    {
        path: '/page/steam-total-hours',
        name: 'SteamTotalHours',
        component: SteamTotalHours,
    },
    {
        path: '/page/steam-hours-per-day',
        name: 'SteamHoursPerDay',
        component: SteamHoursPerDay,
    },
    {
        path: '/blog',
        name: 'Blog',
        component: Blog,
    },
    {
        path: '/blog/steam-deck-sale',
        name: 'SteamDeckSale',
        component: SteamDeckSale,
    },
    {
        path: '/blog/xbox-game-pass-price-update',
        name: 'XboxGamePassPriceUpdate',
        component: XboxGamePassPriceUpdate,
    },
    {
        path: '/blog/steam-machine-price',
        name: 'SteamMachinePrice',
        component: SteamMachinePrice,
    },
    {
        path: '/blog/game-pass-steam-deck-xodus',
        name: 'GamePassSteamDeck',
        component: GamePassSteamDeck,
    },
    {
        path: '/blog/most-played-steam-games-september-2026',
        name: 'MostPlayedSeptember2026',
        component: MostPlayedSeptember2026,
    },
    ...newsPosts().map(post => ({
        path: `/blog/${post.slug}`,
        name: `News:${post.slug}`,
        component: NewsPost,
        props: { post },
    })),
    {
        path: '/privacy',
        name: 'Privacy',
        component: Privacy,
    },
    {
        path: '/about',
        name: 'About',
        component: About,
    },
    {
        path: '/settings',
        name: 'Settings',
        component: Settings,
    },
    {
        path: '/',
        name: 'DashboardHome',
        component: Dashboard,
    },
    {
        path: '/user/:steamId',
        name: 'Dashboard',
        component: Dashboard,
    },
    {
        path: '/:pathMatch(.*)*',
        name: 'NotFound',
        component: NotFound,
    },
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
});

export default router;
